import React, { FC } from 'react';
import styled from 'styled-components';
import { TaskPriorityChanged } from 'api/notifications/meta';
import { Priority as PriorityAtom } from 'components/atoms/priority';
import { BodyShort01 } from 'components/styles';
import { useTranslation } from 'hooks/use-translation';
import { FieldChangedMessage } from './field-changed';

const Priority = styled(PriorityAtom)`
  margin: 0;
  padding-top: 0;
  padding-bottom: 0;
  ${BodyShort01};
`;

export const TaskPriorityChangedView: FC<{ meta: TaskPriorityChanged }> = ({
  meta: { by, from, to },
}) => (
  <FieldChangedMessage
    name={useTranslation('fields.priority')}
    by={by}
    from={
      from ? (
        <Priority priority={{ color: from.color!, label: from.value }} />
      ) : null
    }
    to={
      to ? <Priority priority={{ color: to.color!, label: to.value }} /> : null
    }
  />
);
